import React from "react";
import {
  TableCell,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

const ReportDetailsProduct = ({ data, currencyFormatter }) => {
  const useStyles = makeStyles(() => ({
    header: {
      backgroundColor: "#445851",
      border: "1px solid white",
      borderBottom: 0,
      color: "white",
    },
    cell: {
      border: "1px solid #c7c7c7",
    },
    cellName: {
      width: "50%",
    },
    cellQuantity: {
      width: "25%",
    },
    cellPrice: {
      width: "25%",
    },
    center: {
      textAlign: "center",
    },
    right: {
      textAlign: "right",
    },
  }));

  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell className={clsx(classes.header, classes.cellName)}>
              Variant{" "}
            </TableCell>{" "}
            <TableCell
              className={clsx(
                classes.header,
                classes.cellQuantity,
                classes.center
              )}
            >
              Quantity{" "}
            </TableCell>{" "}
            <TableCell
              className={clsx(classes.header, classes.cellPrice, classes.right)}
            >
              Amount{" "}
            </TableCell>{" "}
          </TableRow>{" "}
        </TableHead>
        <TableBody>
          {" "}
          {data.length > 0 ? (
            data.map((product, index) => (
              <TableRow key={index}>
                <TableCell className={classes.cell}> {product.name} </TableCell>{" "}
                <TableCell className={clsx(classes.cell, classes.center)}>
                  {" "}
                  {product.quantity}{" "}
                </TableCell>{" "}
                <TableCell className={clsx(classes.cell, classes.right)}>
                  {" "}
                  {currencyFormatter.format(
                    (product.quantity * parseFloat(product.price)).toFixed(2)
                  )}{" "}
                </TableCell>{" "}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} className={classes.center}>
                No records to display{" "}
              </TableCell>{" "}
            </TableRow>
          )}{" "}
        </TableBody>{" "}
      </Table>{" "}
    </TableContainer>
  );
};

export default ReportDetailsProduct;
